import React from "react";

const AllergyAlertCard = ({
  allergyName = "Unconfirmed",
  reaction = "",
  verification = "Unconfirmed",
  onsetDate = "Unspecified",
  isDarkTheme = true,
  category = [],
  reactionCodes = "",
}) => {
  const useResponsiveStyles = () => {
    return {
      isMobile: window.innerWidth < 600,
    };
  };

  const { isMobile } = useResponsiveStyles();

  const styles = createStyles(isMobile, isDarkTheme);
  const iconColor = isDarkTheme ? "#B8B8D9" : "#5D5FEF";

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <div style={styles.iconContainer}>
          <svg
            width={isMobile ? "14" : "16"}
            height={isMobile ? "14" : "16"}
            viewBox="0 0 24 24"
            fill="none"
            stroke={iconColor}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
          </svg>
        </div>
        <div style={styles.iconContainer}>
          <svg
            width={isMobile ? "14" : "16"}
            height={isMobile ? "14" : "16"}
            viewBox="0 0 24 24"
            fill="none"
            stroke={iconColor}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
        </div>
        <div style={styles.iconContainer}>
          <svg
            width={isMobile ? "14" : "16"}
            height={isMobile ? "14" : "16"}
            viewBox="0 0 24 24"
            fill="none"
            stroke={iconColor}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="18" y1="20" x2="18" y2="10" />
            <line x1="12" y1="20" x2="12" y2="4" />
            <line x1="6" y1="20" x2="6" y2="14" />
          </svg>
        </div>
        <h5 style={styles.title}>{allergyName}</h5>
      </div>

      <div style={styles.detailsContainer}>
        {/* Details */}
        {reaction && (
          <div style={styles.detailRow}>
            <span style={styles.label}>Reaction:</span>
            <span style={styles.value}>{reaction}</span>
          </div>
        )}

        {category.length > 0 && (
          <div style={styles.detailRow}>
            <span style={styles.label}>Category:</span>
            <span style={styles.value}>{category.join(", ")}</span>
          </div>
        )}

        {reactionCodes && (
          <div style={styles.detailRow}>
            <span style={styles.label}>Reaction Codes:</span>
            <span style={styles.value}>{reactionCodes}</span>
          </div>
        )}
      </div>
    </div>
  );
};

const createStyles = (isMobile, isDarkTheme) => ({
  container: {
    backgroundColor: isDarkTheme ? "#433F81" : "#dfe0f7",
    borderRadius: "12px",
    padding: isMobile ? "10px" : "14px",
    color: isDarkTheme ? "white" : "#333",
    width: "100%",
    maxWidth: "1000px",
    boxShadow: isDarkTheme
      ? "0 8px 24px rgba(0,0,0,0.25)"
      : "0 4px 16px rgba(93, 95, 239, 0.12)",
    fontFamily: "Arial, sans-serif",
    transition: "all 0.3s ease",
  },

  header: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "6px",
    marginBottom: "8px",
    paddingBottom: "8px",
    borderBottom: `2px solid ${isDarkTheme ? "#5A5698" : "#c9caf0"}`,
  },

  iconContainer: {
    minWidth: isMobile ? "14px" : "16px",
    minHeight: isMobile ? "14px" : "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  title: {
    fontSize: isMobile ? "14px" : "15px",
    fontWeight: "600",
    margin: 0,
    color: isDarkTheme ? "white" : "#333",
    letterSpacing: "-0.02em",
  },

  detailsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },

  detailRow: {
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    gap: isMobile ? "4px" : "10px",
    alignItems: isMobile ? "flex-start" : "center",
  },

  label: {
    color: isDarkTheme ? "#B8B8D9" : "#5D5FEF",
    fontSize: "13px",
    fontWeight: "500",
    minWidth: isMobile ? "auto" : "140px",
  },

  value: {
    fontSize: "13px",
    fontWeight: "600",
    color: isDarkTheme ? "white" : "#333",
  },
});

export default AllergyAlertCard;
